import React, { Component } from "react";
import { YMaps, Map, ObjectManager, Control } from "react-yandex-maps";
import { withRouter } from "react-router";
import { withWrapper } from "create-react-server/wrapper";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import map from "modules/map";
import "./YandexMap.css";

class YandexMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      libraries: [],
      center: [55.76, 37.62],
      height: "100%",
      zoom: 12
    };

    props.getLibraries();
    if (this.props.match.params.id) {
      this.state.height = "99.9%";
      if (this.refs.ymaps) this.refs.ymaps.className = "map_hide";
    } else {
      this.state.height = "100%";
      if (this.refs.ymaps) this.refs.ymaps.className = "map_show";
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.id) {
      this.setState({ libraries: nextProps.libraries, zoom: 17 });
      if (nextProps.libraries.length !== 0) {
        for (let i = 0; i < nextProps.libraries.length; i++) {
          if (nextProps.libraries[i].id == nextProps.match.params.id) {
            let center = nextProps.libraries[i].geometry.coordinates.map(
              function(el) {
                return Number(el);
              }
            );
            this.setState({ center: center });
            break;
          }
        }
      }
      this.setState({ height: "99.9%" });
      if (this.refs.ymaps) this.refs.ymaps.className = "map_hide";
    } else {
      this.setState({ libraries: nextProps.libraries, zoom: 12 });

      this.setState({ height: "100%" });
      if (this.refs.ymaps) this.refs.ymaps.className = "map_show";
    }
  }

  handleBalloonClick(id) {
    if (id) {
      this.props.history.push(`/libraries/${id}`);
    }
  }

  addDecay(ymaps) {
    if (ymaps) {
      // ymaps.container._element.querySelector('.ymaps-2-1-59-ground-pane').style.filter = 'grayscale(100%)'
      ymaps.behaviors._behaviors.scrollZoom.disable();
    }
  }

  render() {
    return (
      <div ref="ymaps" className="ymaps-container content">
        <YMaps>
          <Map
            state={{
              center: this.state.center,
              zoom: this.state.zoom,
              controls: []
            }}
            height={this.state.height}
            width="100%"
            instanceRef={ymaps => this.addDecay(ymaps)}
            options={{ suppressMapOpenBlock: true }}
          >
            <ObjectManager
              options={{
                clusterize: true,
                gridSize: 32
              }}
              objects={{
                preset: "islands#lightBlueIcon"
              }}
              clusters={{
                preset: "islands#lightBlueClusterIcons"
              }}
              features={this.state.libraries}
              onClick={e =>
                this.handleBalloonClick(
                  e.originalEvent.currentTarget.objects.hint._activeObjectId
                )
              }
            />
            <Control type="ZoomControl" />
          </Map>
        </YMaps>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  libraries: state.map.libraries,
  library: state.library.library
});

const mapDispatchToProps = dispatch => ({
  getLibraries: bindActionCreators(map.actions.getLibraries, dispatch),
  selectLibrary: bindActionCreators(map.actions.selectLibrary, dispatch)
});

export default withWrapper(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(YandexMap)
  )
);



// WEBPACK FOOTER //
// ./src/components/YandexMap/YandexMap.js